import { computed, ComputedRef, Ref, unref } from 'vue';
import { MaybeComputedRef } from '@vueuse/core';
import { VirtualPortfolioItem } from '@libs/api-reference';
import type { PortfolioItemWithPrices } from '@core/portfolio';

import { ALL_SYMBOLS_SORT_OPTIONS } from '../constants';

export default function useSortSymbols({
  defaultSymbols,
  defaultSortValue,
}: {
  defaultSymbols: ComputedRef<
    Array<PortfolioItemWithPrices | VirtualPortfolioItem>
  >;
  defaultSortValue: MaybeComputedRef<string>;
}) {
  const sort = computed(() => {
    const sortBy =
      unref(defaultSortValue) || ALL_SYMBOLS_SORT_OPTIONS.alphabetical.value;

    return Object.values(ALL_SYMBOLS_SORT_OPTIONS).find(
      (option) => option.value === sortBy
    );
  });

  const symbols = computed(() => {
    if (typeof sort.value?.sortFunction === 'function') {
      return defaultSymbols.value?.sort(sort.value.sortFunction);
    } else {
      return defaultSymbols.value;
    }
  });

  return {
    symbols,
    sort,
  };
}
